import { useRef } from "react";
import { getMLRstatus, getSaveAssets, preview } from "../../services/apis";
import { normalizeLayerComponent } from "../../Uitls/Util";
import { isDisabled } from "../../Uitls/veeva";
import { ensureHitAreaAnimationEntries } from "../../components/RightPanel/HitAreaModal/utils";
import { orderLayersByZIndex } from "../utils/editorMainPageUtils";

const buildCanvasComponentsFromAssetpages = (
  assetpages,
  { editModuleClicked, imageOnCanvas, componentType },
) => {
  const page = assetpages?.[0];
  if (!page?.assetpagecomponent?.length) {
    return {
      components: [],
      anim: {},
      meta: {
        count: 0,
        droppedTextIds: [],
        droppedComponentIds: [],
        droppedTitleIds: [],
        reusableTextIdsArray: [],
        claimReferencesFootnotes: {
          footnotes: [],
          references: [],
          abbreviation: [],
        },
        scrollClaimReferencesFootnotes: {
          footnotes: [],
          references: [],
          abbreviation: [],
        },
      },
    };
  }

  let tempLayerCompData = [];
  let animationObj = {};
  let totalFootnotes = [],
    totalReferences = [],
    totalAbbreviation = [];
  let scrollbarTotalFootnotes = [],
    scrollbarTotalReferences = [],
    scrollbarTotalAbbreviation = [];
  let totalComponents = [],
    totalMatchTexts = [],
    totalReusableTextIds = [],
    totalTitle = [];
  let totalClaims = [];

  page.assetpagecomponent.forEach((element, index) => {
    const elemCSSProp = { ...(element?.components || {}) };
    const coOrdinates = { x: elemCSSProp.left, y: elemCSSProp.top };
    const compType =
      element?.componentType === "Text" || element?.componentType === "Shape"
        ? element?.components?.textComponentType?.addContent
        : element?.componentType;
    let constructObj;
    if (compType === "Image") {
      constructObj = imageOnCanvas(
        "fromGetAssets",
        elemCSSProp.background,
        coOrdinates.x,
        coOrdinates.y,
        elemCSSProp.filename,
        elemCSSProp,
        elemCSSProp.width,
        elemCSSProp.height,
        index,
      );
    } else {
      constructObj = componentType[compType]?.(
        coOrdinates,
        null,
        elemCSSProp,
        index,
      );
    }

    if (!constructObj) return;
    if (
      Object.prototype.hasOwnProperty.call(
        element.components || {},
        "animationObj",
      )
    ) {
      const srcAnim = element.components.animationObj || {};
      animationObj = {
        ...animationObj,
        [constructObj.id]: {
          ...srcAnim,
          timeLine: {
            ...(srcAnim.timeLine || {}),
            id: `slider-TimeLine${index}`,
          },
        },
      };
    }
    if (
      element.componentType === "Scrollbar" &&
      Array.isArray(element.components?.scrollbarComponents)
    ) {
      let countScrollComp = page.assetpagecomponent.length;
      element.components.scrollbarComponents.forEach((component) => {
        component.id = `${component.componentType}${countScrollComp++}`;
      });
      constructObj.scrollbarComponents = element.components.scrollbarComponents;
      constructObj.componentStyles = {
        ...(constructObj.componentStyles || {}),
        scrollbarHeight: element.components.scrollbarHeight,
      };
    }
    if (elemCSSProp.componentId) totalComponents.push(elemCSSProp.componentId);
    if (elemCSSProp.titleId) totalTitle.push(elemCSSProp.titleId);

    if (elemCSSProp.matchTextId) {
      totalMatchTexts.push(elemCSSProp.matchTextId);
      if (elemCSSProp.claimFootnotes) {
        totalFootnotes.push({
          matchTextId: elemCSSProp.matchTextId,
          componentId: elemCSSProp.componentId,
          footnotesText: elemCSSProp.claimFootnotes,
          footnoteSymbol: elemCSSProp.footnoteSymbol,
        });
      }
      if (elemCSSProp.claimReferences) {
        totalReferences.push({
          matchTextId: elemCSSProp.matchTextId,
          componentId: elemCSSProp.componentId,
          referenceArray: elemCSSProp.claimReferences,
        });
      }
      if (elemCSSProp.claimAbbreviation) {
        totalAbbreviation.push({
          matchTextId: elemCSSProp.matchTextId,
          componentId: elemCSSProp.componentId,
          abbreviationText: elemCSSProp.claimAbbreviation,
        });
      }
    }

    if (elemCSSProp.claimId) {
      totalClaims.push(elemCSSProp.claimId);
      if (elemCSSProp.claimFootnotes) {
        totalFootnotes.push({
          claimId: elemCSSProp.claimId,
          footnotesText: elemCSSProp.claimFootnotes,
          footnoteSymbol: elemCSSProp.footnoteSymbol,
        });
      }
      if (elemCSSProp.claimReferences) {
        totalReferences.push({
          claimId: elemCSSProp.claimId,
          referenceArray: elemCSSProp.claimReferences,
        });
      }
      if (elemCSSProp.claimAbbreviation) {
        totalAbbreviation.push({
          claimId: elemCSSProp.claimId,
          abbreviationText: elemCSSProp.claimAbbreviation,
        });
      }
    }

    if (elemCSSProp.reusableTextId)
      totalReusableTextIds.push(elemCSSProp.reusableTextId);
    tempLayerCompData.push(constructObj);
    if (
      Array.isArray(element.components?.scrollbarComponents) &&
      element.components.scrollbarComponents.length
    ) {
      element.components.scrollbarComponents.forEach((scrollComp) => {
        if (scrollComp.reusableTextId)
          totalReusableTextIds.push(scrollComp.reusableTextId);
        if (scrollComp.claimId) {
          totalClaims.push(scrollComp.claimId);
          if (scrollComp.claimFootnotes) {
            scrollbarTotalFootnotes.push({
              claimId: scrollComp.claimId,
              footnotesText: scrollComp.claimFootnotes,
              footnoteSymbol: scrollComp.footnoteSymbol,
            });
          }
          if (scrollComp.claimReferences) {
            scrollbarTotalReferences.push({
              claimId: scrollComp.claimId,
              referenceArray: scrollComp.claimReferences,
            });
          }
          if (scrollComp.claimAbbreviation) {
            scrollbarTotalAbbreviation.push({
              claimId: scrollComp.claimId,
              abbreviationText: scrollComp.claimAbbreviation,
            });
          }
        }
        if (scrollComp.componentId) totalComponents.push(scrollComp.componentId);
        if (scrollComp.titleId) totalTitle.push(scrollComp.titleId);
        if (scrollComp.matchTextId) {
          totalMatchTexts.push(scrollComp.matchTextId);
          if (scrollComp.claimFootnotes) {
            scrollbarTotalFootnotes.push({
              matchTextId: scrollComp.matchTextId,
              componentId: scrollComp.componentId,
              footnotesText: scrollComp.claimFootnotes,
              footnoteSymbol: scrollComp.footnoteSymbol,
            });
          }
          if (scrollComp.claimReferences) {
            scrollbarTotalReferences.push({
              matchTextId: scrollComp.matchTextId,
              componentId: scrollComp.componentId,
              referenceArray: scrollComp.claimReferences,
            });
          }
          if (scrollComp.claimAbbreviation) {
            scrollbarTotalAbbreviation.push({
              matchTextId: scrollComp.matchTextId,
              componentId: scrollComp.componentId,
              abbreviationText: scrollComp.claimAbbreviation,
            });
          }
        }
      });
    }
  });
  scrollbarTotalFootnotes.reverse();
  scrollbarTotalReferences.reverse();
  scrollbarTotalAbbreviation.reverse();
  totalFootnotes.reverse();
  totalReferences.reverse();
  totalAbbreviation.reverse();
  totalMatchTexts.reverse();
  totalClaims.reverse();
  let meta = {
    droppedTextIds: totalMatchTexts,
    droppedComponentIds: totalComponents,
    droppedTitleIds: totalTitle,
    reusableTextIdsArray: totalReusableTextIds,
    claimReferencesFootnotes: {
      footnotes: totalFootnotes,
      references: totalReferences,
      abbreviation: totalAbbreviation,
    },
    scrollClaimReferencesFootnotes: {
      footnotes: scrollbarTotalFootnotes,
      references: scrollbarTotalReferences,
      abbreviation: scrollbarTotalAbbreviation,
    },
    count:
      tempLayerCompData.length +
      tempLayerCompData.reduce(
        (sum, c) => sum + (c.scrollbarComponents?.length || 0),
        0,
      ),
    claimsArray: totalClaims,
  };
  if (editModuleClicked) {
    const keepIfNoData = (c = {}) =>
      !(
        c.componentId ||
        c.claimId ||
        c.reusableTextId ||
        c.matchTextId ||
        c.titleId
      );

    let filtered = tempLayerCompData
      .map((item) => ({
        ...item,
        scrollbarComponents: (item.scrollbarComponents || []).filter(
          keepIfNoData,
        ),
      }))
      .filter(keepIfNoData);
    filtered.forEach((c) => {
      if (c.reference) c.froalaText = "<b>Reference: </b>";
      if (c.footnotes) c.froalaText = "<b>Footnotes: </b>";
      if (c.abbreviation) c.froalaText = "<b>Abbreviation: </b>";
      (c.scrollbarComponents || []).forEach((sc) => {
        if (sc.reference) sc.froalaText = "<b>Reference: </b>";
        if (sc.footnotes) sc.froalaText = "<b>Footnotes: </b>";
        if (sc.abbreviation) sc.froalaText = "<b>Abbreviation: </b>";
      });
    });
    meta = {
      droppedTextIds: [],
      droppedComponentIds: [],
      droppedTitleIds: [],
      reusableTextIdsArray: [],
      claimReferencesFootnotes: {
        footnotes: [],
        references: [],
        abbreviation: [],
      },
      scrollClaimReferencesFootnotes: {
        footnotes: [],
        references: [],
        abbreviation: [],
      },
      count:
        tempLayerCompData.length +
        tempLayerCompData.reduce(
          (sum, c) => sum + (c.scrollbarComponents?.length || 0),
          0,
        ),
      claimsArray: [],
    };

    tempLayerCompData = filtered;
  }
  return {
    components: orderLayersByZIndex(
      tempLayerCompData.map(normalizeLayerComponent),
    ),
    anim: animationObj,
    meta,
  };
};

export const useEditorAssetHydration = ({
  showToastRef,
  NavigateToLandingPage,
  ErrComponentToRender,
  setLoadingModules,
  setundoFlag,
  setUndoAnimationObjFlag,
  setPreviewRedirectHome,
  setpreviewURl,
  setPreView,
  renderAppliedFonts,
  setVeevaDocumentNumber,
  fetchAllSizesBanner,
  fetchOneTimeAssetStatus,
  setGenericInfo,
  setCanvasDimension,
  appData,
  setLinkedModulesType,
  setModules,
  setToggleAnimatedBanner,
  setShowBannertype,
  setShowAssettype,
  setShowBannerName,
  setBannerData,
  setDamsId,
  setMLRstatus,
  setIsModuleExist,
  setModuleCardsDataLHS,
  isOneTimeAsset,
  fetchAllChildModules,
  fetchAllClaims,
  setModuleSearchExpression,
  editModuleClicked,
  imageOnCanvas,
  componentType,
  setLayerLengthAtRefresh,
  setRefreshed,
  setLayerCompData,
  setSelectedComponent,
  setAnimationObject,
  setDroppedTextIds,
  setDroppedComponentIds,
  setDroppedTitleIds,
  setReusableTextIdsArray,
  setClaimReferencesFoonotes,
  setScrollClaimReferencesFoonotes,
  setClaimsArray,
  setCount,
  setRefreshCompleted,
  setIsOneTimeAsset,
  setDraggerWidth,
}) => {
  const activeRequestRef = useRef({ token: 0, assetId: null });

  const resetEditorCanvasState = () => {
    setLayerCompData([]);
    setSelectedComponent({});
    setAnimationObject({});
    setDroppedTextIds([]);
    setDroppedComponentIds([]);
    setDroppedTitleIds([]);
    setReusableTextIdsArray([]);
    setClaimReferencesFoonotes({
      footnotes: [],
      references: [],
      abbreviation: [],
    });
    setScrollClaimReferencesFoonotes({
      footnotes: [],
      references: [],
      abbreviation: [],
    });
    setClaimsArray([]);
    setCount(0);
    setLayerLengthAtRefresh([]);
    setRefreshed(false);
  };

  const getLatestMLRStatus = async (id) => {
    try {
      const response = await new Promise((resolve, reject) => {
        getMLRstatus(id, (data, err, errorCode) => {
          if (err) {
            reject("Not Submitted");
          } else {
            resolve(data?.data?.mlrStatus || "Not Submitted");
          }
        });
      });

      setMLRstatus(response);
      return response;
    } catch (error) {
      setMLRstatus("Not Submitted");
      return "Not Submitted";
    }
  };

  const getEditSaveAssets = (id, moduleEdited) => {
    const requestToken = activeRequestRef.current.token + 1;
    activeRequestRef.current = { token: requestToken, assetId: id };

    resetEditorCanvasState();
    setSelectedComponent({});
    setCanvasDimension((prev) => ({
      ...prev,
      width: 0,
      height: 0,
    }));
    appData.updateGenericInfo({
      ...appData?.genericInfo,
      bannerSize: "",
      Width: 0,
      Height: 0,
    });
    const isCurrentRequest = () =>
      activeRequestRef.current.token === requestToken &&
      activeRequestRef.current.assetId === id;

    setLoadingModules(true);

    getSaveAssets(id, async (response, err, errorCode) => {
      try {
        if (!isCurrentRequest()) {
          return;
        }

        if (err) {
          ErrComponentToRender(errorCode);
          setundoFlag(false);
          setUndoAnimationObjFlag(false);

          if (errorCode === 500) {
            NavigateToLandingPage("Asset Id not found");
            setLoadingModules(false);
            return;
          }

          setLoadingModules(false);
          return;
        }

        const { data } = response || {};
        if (!data) {
          resetEditorCanvasState();
          setLoadingModules(false);
          return;
        }

        const currentUserName = localStorage.getItem("currentUserName");
        setPreviewRedirectHome(false);

        if (data.lockStatus === "Locked") {
          const updatedBy = data.updatedByName;
          const createdBy = data.createdByName;
          const isOwner =
            currentUserName &&
            (createdBy === currentUserName || updatedBy === currentUserName);

          if (!isOwner) {
            const editorHtml = data.editorData?.html;

            if (!editorHtml) {
              setLoadingModules(false);
              window.alert("Restricted");
              return;
            }

            const previewPayload = {
              html: editorHtml,
              fileName: data.editorData?.fileName || data.assetName,
            };

            setPreviewRedirectHome(true);

            preview(previewPayload, (resp, apiErr, previewErrorCode) => {
              if (!isCurrentRequest()) {
                return;
              }

              setLoadingModules(false);

              if (apiErr) {
                const errComponent = ErrComponentToRender(previewErrorCode);
                console.error("preview error:", errComponent);
                window.alert("Restricted");
                return;
              }

              if (resp?.data) {
                setpreviewURl(resp.data);
                setPreView(true);
              } else {
                window.alert("Restricted");
              }
            });
            return;
          }
        }

        const marketName = data.marketName;
        const mlrStatus = data.mlrStatus ?? null;

        const bannerDisabled = isDisabled({
          marketName,
          mlrStatus,
        });

        if (bannerDisabled && showToastRef.current) {
          showToastRef.current = false;
          NavigateToLandingPage(
            `The banner can't be edited because it is in the ${mlrStatus} status.`,
          );
          setLoadingModules(false);
          return;
        }

        if (data.lockStatus === "Locked" && data.madeBy === "others") {
          NavigateToLandingPage(`${data.assetType} Expired`);
          setLoadingModules(false);
          return;
        } else if (data.assetStatus === "INACTIVE") {
          NavigateToLandingPage(`${data.assetType} is Deleted`);
          setLoadingModules(false);
          return;
        }

        if (Array.isArray(data.assetpages) && data.assetpages.length > 0) {
          renderAppliedFonts(response);
        }

        // it was used in dev but but not in qa before
        const oneTimeAssetFromAsset = Boolean(data?.oneTimeAsset);
        window.localStorage.setItem(
          "oneTimeAsset",
          JSON.stringify(oneTimeAssetFromAsset),
        );
        setIsOneTimeAsset(oneTimeAssetFromAsset);

        const damDocNumber = data?.damDocNumber;
        setVeevaDocumentNumber(damDocNumber);
        fetchAllSizesBanner(damDocNumber);
        window.localStorage.setItem("damDocNumber", damDocNumber || "");
        const oneTimeAssetFromPayload =
          typeof data?.oneTimeAsset === "boolean" ? data.oneTimeAsset : false;
        fetchOneTimeAssetStatus(damDocNumber, oneTimeAssetFromPayload);
        const mrlCurrentStatus = await getLatestMLRStatus(damDocNumber)
        localStorage.setItem("mlrStatus", mrlCurrentStatus);

        const canvasScale = data?.attributes?.canvasScale ?? {
          divisions: 30,
          width: 1359,
        };
        // Keep saved timeline width; only fall back to 675 for brand-new assets.
        const savedDraggerWidth = Number(data?.attributes?.draggerWidth);
        let restoredDraggerWidth =
          Number.isFinite(savedDraggerWidth) && savedDraggerWidth > 0
            ? savedDraggerWidth
            : null;

        if (data?.attributes?.customTemp) {
          setGenericInfo((prev) => ({
            ...prev,
            Height: data.height ?? 0,
            Width: data.width ?? 0,
          }));
        } else {
          setGenericInfo((prev) => ({ ...prev, Height: 0, Width: 0 }));
          setCanvasDimension((prev) => ({
            ...prev,
            height: data.height ?? prev.height,
            width: data.width ?? prev.width,
          }));
        }

        setCanvasDimension((prev) => ({
          ...prev,
          height: data.height ?? prev.height,
          width: data.width ?? prev.width,
          fps: data?.attributes?.fps ?? 60,
          backgroundColor: data?.attributes?.backgroundColor ?? {
            r: 255,
            g: 255,
            b: 255,
            a: 1,
          },
          globalLink: data?.attributes?.globalLink || "https://",
          checkGloballink: !!data?.attributes?.checkGloballink,
          checkLoops: data?.attributes?.checkLoops,
          loopAnimation: data?.attributes?.loopAnimation || 0,
          refreshed: true,
          custom: data?.attributes?.custom,
          customTemp: data?.attributes?.customTemp,
          bannerType: data?.attributes?.bannerSizeType,
        }));

        appData.setCustomTempSize(data?.attributes?.customTemp);

        const linkedModulesType =
          data?.attributes?.linkedModules?.linkedModules;
        setLinkedModulesType(linkedModulesType);

        if (linkedModulesType === "veevaModule") {
          const moduleId = (data?.modules || []).map((m) => m.moduleId);
          setModules({ moduleId });
        } else {
          const filtered = (data?.modules || []).filter((m) => m.isParent === true);
          const moduleId = filtered.map((m) => m.moduleId);
          setModules({ moduleId });
        }

        setToggleAnimatedBanner(!!data.isAnimated);
        setShowBannertype(data.isAnimated ? "Animated" : "Static");
        setShowAssettype(data.assetType);
        setShowBannerName(data?.assetName);

        appData.setbannerName(data?.assetName);
        appData.setbannerType(data.isAnimated ? "Animated" : "Static");
        appData.setCampaignId(data.campaignId);

        setBannerData(data);
        appData.setBannersEditCardData({ cards: data });
        appData.setCardData({ cards: [], search: "search" });

        appData.setAssetInfo({ assetId: data.id, assetName: data.assetName });

        if (data?.attributes?.linkedModules) {
          appData.setVeevaModulesLinked(true);
        }

        appData.updateGenericInfo({
          ...appData?.genericInfo,
          brand: data.brandName,
          campaign: data.campaign,
          market: data.marketName,
          canvasScale,
          draggerWidth: restoredDraggerWidth ?? 675,
          searchedFields: data?.attributes?.searchExpression,
          searchFieldsTobeSaved:
            linkedModulesType === "nextModule"
              ? data?.attributes?.searchExpression
              : {
                moduleNameArray:
                  data?.attributes?.searchExpression?.moduleNameArray ||
                  data?.attributes?.searchExpression?.name,
                brandName: data?.attributes?.searchExpression?.brandName,
                claimCategoryArray:
                  data?.attributes?.searchExpression?.claimCategory ||
                  data?.attributes?.searchExpression?.claimCategoryArray,
                assetNameArray: data?.attributes?.searchExpression?.assetName,
              },
          linkedData: {
            activeCards: {
              moduleId: (data?.modules || []).map((module) => module.moduleId),
            },
            values:
              linkedModulesType === "nextModule"
                ? data?.attributes?.searchExpression
                : {
                  moduleNameArray:
                    data?.attributes?.searchExpression?.moduleNameArray ||
                    data?.attributes?.searchExpression?.name,
                  brandName: data?.attributes?.searchExpression?.brandName,
                  claimCategoryArray:
                    data?.attributes?.searchExpression?.claimCategory ||
                    data?.attributes?.searchExpression?.claimCategoryArray,
                  assetNameArray: data?.attributes?.searchExpression?.assetName,
                },
          },
        });

        setDamsId(data?.assetMlr?.[0]?.veevaDocNumber ?? "_");
        appData.setMarketCode(data.marketCode);
        setMLRstatus(data?.assetMlr?.[0]?.reviewStatus ?? "Not Submitted");
        appData.setBrandId(data.brandId);

        const modulesArr = response?.data?.modules || [];
        const allModules = modulesArr.map((i) => i.moduleId);
        setIsModuleExist(allModules.length > 0);
        setModuleCardsDataLHS(modulesArr);

        const allChildsModules =
          isOneTimeAsset || Boolean(response?.data?.oneTimeAsset)
            ? []
            : (await fetchAllChildModules(allModules)) || [];

        if (!isCurrentRequest()) {
          return;
        }

        if (!moduleEdited) {
          localStorage.setItem(
            "allSymbols",
            data?.attributes?.moduleSymbols || "NO SYMBOLS",
          );
        }
        if (!isOneTimeAsset) {
          if (
            !data?.attributes?.moduleSymbols ||
            data?.attributes?.moduleSymbols === "NO SYMBOLS"
          ) {
            fetchAllClaims([...allModules, ...allChildsModules], false);
          } else {
            fetchAllClaims(
              [...allModules, ...allChildsModules],
              data?.attributes?.moduleSymbols,
            );
          }
        } else {
          setLoadingModules(false);
        }
        setModuleSearchExpression(data?.attributes?.searchExpression);

        if (Array.isArray(data.assetpages) && data.assetpages.length > 0) {
          const { components, anim, meta } = buildCanvasComponentsFromAssetpages(
            data.assetpages,
            {
              editModuleClicked,
              imageOnCanvas,
              componentType,
            },
          );

          // Timeline bar should cover the longest saved layer (and saved draggerWidth).
          const maxSavedLayerWidth = components.reduce(
            (maxWidth, component) => {
              const width = Number(component?.componentStyles?.layerWidth);
              return Number.isFinite(width) && width > maxWidth ? width : maxWidth;
            },
            0,
          );

          // Prefer saved values: if either was saved longer than default, use that.
          const finalDraggerWidth =
            restoredDraggerWidth || maxSavedLayerWidth
              ? Math.max(restoredDraggerWidth || 0, maxSavedLayerWidth || 0)
              : 675;

          if (typeof setDraggerWidth === "function") {
            setDraggerWidth(finalDraggerWidth);
          }
          
          appData.updateGenericInfo({
            ...appData?.genericInfo,
            draggerWidth: finalDraggerWidth,
          });

          if (components.length > 0) {
            setLayerLengthAtRefresh(JSON.parse(JSON.stringify(components)));
            setRefreshed(true);
          }

          ensureHitAreaAnimationEntries(anim, components);
          setLayerCompData(components);
          setSelectedComponent(components[components.length - 1] || {});
          
          setAnimationObject(anim);

          setDroppedTextIds(meta.droppedTextIds || []);
          setDroppedComponentIds(meta.droppedComponentIds || []);
          setDroppedTitleIds(meta.droppedTitleIds || []);
          setReusableTextIdsArray(meta.reusableTextIdsArray || []);
          setClaimReferencesFoonotes(
            meta.claimReferencesFootnotes || {
              footnotes: [],
              references: [],
              abbreviation: [],
            },
          );
          setScrollClaimReferencesFoonotes(
            meta.scrollClaimReferencesFootnotes || {
              footnotes: [],
              references: [],
              abbreviation: [],
            },
          );
          setClaimsArray(meta.claimsArray || []);
          setCount(meta.count || 0);
        } else {
          resetEditorCanvasState();
        }

        if (
          data?.assetType === "Banner" &&
          modulesArr.length &&
          linkedModulesType !== "veevaModule"
        ) {
          (data.modules || []).map((m) => m.moduleId);
          appData.setFlagEditBanner(true);
        }

        if (
          data?.assetType === "Banner" &&
          modulesArr.length &&
          linkedModulesType === "veevaModule"
        ) {
          // existing logic...
        }

        setRefreshCompleted((prev) => prev + 1);
      } catch (e) {
        console.error("getEditSaveAssets error:", e);
        if (isCurrentRequest()) {
          setLoadingModules(false);
        }
      }
    });
  };

  return { getEditSaveAssets };
};

